import type { JSX } from 'react';
import type { CardProps } from '@wistia/ui';
import { UIProvider, Card, Text } from '@wistia/ui';

interface CardWithTextProps extends CardProps {
  extraBottomMargin?: boolean;
}

export const CardWithText = ({
  children,
  extraBottomMargin,
  ...props
}: CardWithTextProps): JSX.Element => {
  return (
    <UIProvider>
      <Card
        {...(extraBottomMargin ? { style: { marginBottom: 'var(--wui-space-08)' } } : {})}
        {...props}
      >
        <Text>{children}</Text>
      </Card>
    </UIProvider>
  );
};
